import React from 'react';
import { Tooltip } from 'antd';
import { useI18n } from 'hooks/useI18n';

const DayNavigator = ({ days, selectedDayNumber, onSelectDay }) => {
	const { t } = useI18n();
	const getColor = (day) => {
		if (day.isRestDay) return 'var(--border-color)';
		if (day.items && day.items.length > 0) return '#4d7cfe';
		return 'var(--hover-background)';
	};

	const getTextColor = (day) => {
		if (day.items && day.items.length > 0) return '#fff';
		return 'var(--text-color)';
	};

	return (
		<div className="template-builder-day-nav">
			{days.map((day) => (
				<Tooltip
					key={day.dayNumber}
					title={day.isRestDay ? t('workouts.template.day_nav.day_rest_tooltip', { day: day.dayNumber }) : t('workouts.template.day_nav.day_exercises_tooltip', { day: day.dayNumber, count: day.items?.length || 0 })}
				>
					<div
						onClick={() => onSelectDay(day.dayNumber)}
						className={`template-builder-day-nav__item${selectedDayNumber === day.dayNumber ? ' template-builder-day-nav__item--active' : ''}`}
						style={{
							background: getColor(day),
							color: getTextColor(day),
						}}
					>
						{day.dayNumber}
					</div>
				</Tooltip>
			))}
		</div>
	);
};

export default DayNavigator;
